import { useLocation } from 'react-router';

import { advanceNavigationContext } from '~/utils/navigationContext';

export default function useNavigationContextManager() {
  const { pathname, search } = useLocation();

  advanceNavigationContext(pathname + search);
}
